import React from "react";
import Fabs from "./fabs";
import FabsRight from "./fabsRight";

const Footer = (props) => {
  return (
    <footer style={{ pointerEvents: "none" }}>
      <div className="footer">
        <span className="alignLeft">
          <Fabs {...props} />
        </span>
        <span className="alignRight">
          <FabsRight {...props} />
        </span>
      </div>
    </footer>
  );
};

export default Footer;
